export const copyHtmlElementToClipboard = (element: HTMLElement) => {
  const selection = window.getSelection();
  if (!selection) {
    return;
  }
  selection.removeAllRanges();
  const range = document.createRange();
  range.selectNodeContents(element);
  selection.addRange(range);
  document.execCommand('copy');
  selection.removeAllRanges();
};

export const copyTextToClipboard = (text: string) => {
  const textField = document.createElement('textarea');
  textField.innerHTML = text;
  document.body.appendChild(textField);
  textField.select();
  document.execCommand('copy');
  textField.remove();
};
